module.exports = __webpack_public_path__ + "913e403d42f8af7769fa446ae2e33daf.png";